import { SET_PORTAL } from 'FormsUI/actions/Portal';
const INITIAL_STATE = {};
export function portal(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_PORTAL:
      return action.portal;
    default:
      return state;
  }
}